export default __webpack_public_path__ + "a64a9abefbbe02db74efd2eed91e335c.otf";